







import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  inheritAttrs: true,
  components: {
    VCalendarDatepicker: () =>
      import('v-calendar/lib/components/date-picker.umd')
  }
})
